const countDays = [
  [1, 1, 1, 1, 4],
  [1, 1, 1, 1, 4],
];

const optionsForm = [
  { label: 'Москва', value: 0 },
  { label: 'Санкт-Петербург', value: 1 },
];
const optionsIn = [
  { label: 'Москва', value: 0 },
  { label: 'Санкт-Петербург', value: 1 },
  { label: 'ЦФО', value: 2 },
  { label: 'Нижний Новгород', value: 3 },
  { label: 'Екатеринбург', value: 4 },
];

const priceTitle = ['50 – 200', '200 – 500', '500 – 1500', '1500+'];

const priceFromIn = [
  [
    [295, 270, 255, 240],
    [280, 260, 245, 235],
    [330, 310, 295, 285],
    [330, 310, 295, 285],
    [420, 400, 385, 375],
  ],
  [
    [305, 280, 265, 250],
    [295, 270, 255, 240],
    [405, 380, 365, 355],
    [405, 380, 365, 355],
    [490, 470, 455, 445],
  ],
];

export default {
  textCountPerMonth: 'заказов в месяц',
  textAverageCost: 'средняя стоимость доставки',
  countDays,
  optionsForm,
  optionsIn,
  priceTitle,
  priceFromIn
}
